export function useDataRequestRoutes(dataRequestId: string) {
    //detect a url from an email link, which always uses 'admindatarequests' for any recipient, regardless of their role
    const isFromEmailLink = window.location.pathname.includes(`admindatarequests/${dataRequestId}`);

    return {
        isFromEmailLink,
    };
}
